// @ts-nocheck

import { Route as rootRoute } from '../routes/__root';
import { Route as AboutRoute } from '../routes/about';
import { Route as AccountSecurityRoute } from '../routes/account/security';
import { Route as AccountWriterKeysRoute } from '../routes/account/writer-keys';
import { Route as AdminArtworkChangesRoute } from '../routes/admin/artwork-changes';
import { Route as AdminArtworksUuidRoute } from '../routes/admin/artworks.$uuid';
import { Route as AdminEscrowRoute } from '../routes/admin/escrow';
import { Route as AdminEscrowSaleIdRoute } from '../routes/admin/escrow.$saleId';
import { Route as AdminIndexRoute } from '../routes/admin/index';
import { Route as AdminNotificationsRoute } from '../routes/admin/notifications';
import { Route as AdminNotificationsCreateRoute } from '../routes/admin/notifications.create';
import { Route as AdminPagesRoute } from '../routes/admin/pages';
import { Route as AdminPagesSlugRoute } from '../routes/admin/pages.$slug';
import { Route as AdminProvenanceProposalsRoute } from '../routes/admin/provenance-proposals';
import { Route as AdminRequestsRoute } from '../routes/admin/requests';
import { Route as AdminRolesRoute } from '../routes/admin/roles';
import { Route as AdminUsersRoute } from '../routes/admin/users';
import { Route as AdminUsersIdRoute } from '../routes/admin/users.$id';
import { Route as ArtArtworkIdRoute } from '../routes/art/$artworkId';
import { Route as AuthAcceptTermsRoute } from '../routes/auth/accept-terms';
import { Route as AuthLoginRoute } from '../routes/auth/login';
import { Route as AuthPasswordResetRoute } from '../routes/auth/password-reset';
import { Route as AuthPasswordResetConfirmRoute } from '../routes/auth/password-reset-confirm';
import { Route as CertificateIndexRoute } from '../routes/certificate/index';
import { Route as CertificateSampleRoute } from '../routes/certificate/sample';
import { Route as CliLoginRoute } from '../routes/cli-login';
import { Route as HowItWorksRoute } from '../routes/how-it-works';
import { Route as IndexRoute } from '../routes/index';
import { Route as ItemUuidRoute } from '../routes/item/$uuid';
import { Route as PassportConfirmRequestIdRoute } from '../routes/passport/confirm.$requestId';
import { Route as PrivacyRoute } from '../routes/privacy';
import { Route as PrivacyVersionRoute } from '../routes/privacy.$version';
import { Route as SlaRoute } from '../routes/sla';
import { Route as SlaVersionRoute } from '../routes/sla.$version';
import { Route as TagUuidRoute } from '../routes/tag/$uuid';
import { Route as TagFailedRoute } from '../routes/tag/failed';
import { Route as TagRetiredUuidRoute } from '../routes/tag/retired.$uuid';
import { Route as TermsRoute } from '../routes/terms';
import { Route as TermsVersionRoute } from '../routes/terms.$version';

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/account/security': {
      id: '/account/security';
      path: '/account/security';
      fullPath: '/account/security';
      preLoaderRoute: typeof AccountSecurityRoute;
      parentRoute: typeof rootRoute;
    };
    '/account/writer-keys': {
      id: '/account/writer-keys';
      path: '/account/writer-keys';
      fullPath: '/account/writer-keys';
      preLoaderRoute: typeof AccountWriterKeysRoute;
      parentRoute: typeof rootRoute;
    };
    '/cli-login': {
      id: '/cli-login';
      path: '/cli-login';
      fullPath: '/cli-login';
      preLoaderRoute: typeof CliLoginRoute;
      parentRoute: typeof rootRoute;
    };
    '/art/$artworkId': {
      id: '/art/$artworkId';
      path: '/art/$artworkId';
      fullPath: '/art/$artworkId';
      preLoaderRoute: typeof ArtArtworkIdRoute;
      parentRoute: typeof rootRoute;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRoute;
      parentRoute: typeof rootRoute;
    };
    '/auth/accept-terms': {
      id: '/auth/accept-terms';
      path: '/auth/accept-terms';
      fullPath: '/auth/accept-terms';
      preLoaderRoute: typeof AuthAcceptTermsRoute;
      parentRoute: typeof rootRoute;
    };
    '/auth/login': {
      id: '/auth/login';
      path: '/auth/login';
      fullPath: '/auth/login';
      preLoaderRoute: typeof AuthLoginRoute;
      parentRoute: typeof rootRoute;
    };
    '/auth/password-reset': {
      id: '/auth/password-reset';
      path: '/auth/password-reset';
      fullPath: '/auth/password-reset';
      preLoaderRoute: typeof AuthPasswordResetRoute;
      parentRoute: typeof rootRoute;
    };
    '/auth/password-reset-confirm': {
      id: '/auth/password-reset-confirm';
      path: '/auth/password-reset-confirm';
      fullPath: '/auth/password-reset-confirm';
      preLoaderRoute: typeof AuthPasswordResetConfirmRoute;
      parentRoute: typeof rootRoute;
    };
    '/admin/': {
      id: '/admin/';
      path: '/admin';
      fullPath: '/admin';
      preLoaderRoute: typeof AdminIndexRoute;
      parentRoute: typeof rootRoute;
    };
    '/admin/requests': {
      id: '/admin/requests';
      path: '/admin/requests';
      fullPath: '/admin/requests';
      preLoaderRoute: typeof AdminRequestsRoute;
      parentRoute: typeof rootRoute;
    };
    '/admin/artwork-changes': {
      id: '/admin/artwork-changes';
      path: '/admin/artwork-changes';
      fullPath: '/admin/artwork-changes';
      preLoaderRoute: typeof AdminArtworkChangesRoute;
      parentRoute: typeof rootRoute;
    };
    '/admin/provenance-proposals': {
      id: '/admin/provenance-proposals';
      path: '/admin/provenance-proposals';
      fullPath: '/admin/provenance-proposals';
      preLoaderRoute: typeof AdminProvenanceProposalsRoute;
      parentRoute: typeof rootRoute;
    };
    '/admin/roles': {
      id: '/admin/roles';
      path: '/admin/roles';
      fullPath: '/admin/roles';
      preLoaderRoute: typeof AdminRolesRoute;
      parentRoute: typeof rootRoute;
    };
    '/admin/notifications': {
      id: '/admin/notifications';
      path: '/admin/notifications';
      fullPath: '/admin/notifications';
      preLoaderRoute: typeof AdminNotificationsRoute;
      parentRoute: typeof rootRoute;
    };
    '/admin/notifications/create': {
      id: '/admin/notifications/create';
      path: '/admin/notifications/create';
      fullPath: '/admin/notifications/create';
      preLoaderRoute: typeof AdminNotificationsCreateRoute;
      parentRoute: typeof rootRoute;
    };
    '/admin/users': {
      id: '/admin/users';
      path: '/admin/users';
      fullPath: '/admin/users';
      preLoaderRoute: typeof AdminUsersRoute;
      parentRoute: typeof rootRoute;
    };
    '/admin/artworks/$uuid': {
      id: '/admin/artworks/$uuid';
      path: '/admin/artworks/$uuid';
      fullPath: '/admin/artworks/$uuid';
      preLoaderRoute: typeof AdminArtworksUuidRoute;
      parentRoute: typeof rootRoute;
    };
    '/admin/users/$id': {
      id: '/admin/users/$id';
      path: '/admin/users/$id';
      fullPath: '/admin/users/$id';
      preLoaderRoute: typeof AdminUsersIdRoute;
      parentRoute: typeof rootRoute;
    };
    '/admin/escrow': {
      id: '/admin/escrow';
      path: '/admin/escrow';
      fullPath: '/admin/escrow';
      preLoaderRoute: typeof AdminEscrowRoute;
      parentRoute: typeof rootRoute;
    };
    '/admin/escrow/$saleId': {
      id: '/admin/escrow/$saleId';
      path: '/admin/escrow/$saleId';
      fullPath: '/admin/escrow/$saleId';
      preLoaderRoute: typeof AdminEscrowSaleIdRoute;
      parentRoute: typeof rootRoute;
    };
    '/item/$uuid': {
      id: '/item/$uuid';
      path: '/item/$uuid';
      fullPath: '/item/$uuid';
      preLoaderRoute: typeof ItemUuidRoute;
      parentRoute: typeof rootRoute;
    };
    '/passport/confirm/$requestId': {
      id: '/passport/confirm/$requestId';
      path: '/passport/confirm/$requestId';
      fullPath: '/passport/confirm/$requestId';
      preLoaderRoute: typeof PassportConfirmRequestIdRoute;
      parentRoute: typeof rootRoute;
    };
    '/tag/$uuid': {
      id: '/tag/$uuid';
      path: '/tag/$uuid';
      fullPath: '/tag/$uuid';
      preLoaderRoute: typeof TagUuidRoute;
      parentRoute: typeof rootRoute;
    };
    '/tag/failed': {
      id: '/tag/failed';
      path: '/tag/failed';
      fullPath: '/tag/failed';
      preLoaderRoute: typeof TagFailedRoute;
      parentRoute: typeof rootRoute;
    };
    '/tag/retired/$uuid': {
      id: '/tag/retired/$uuid';
      path: '/tag/retired/$uuid';
      fullPath: '/tag/retired/$uuid';
      preLoaderRoute: typeof TagRetiredUuidRoute;
      parentRoute: typeof rootRoute;
    };
    '/certificate/': {
      id: '/certificate/';
      path: '/certificate';
      fullPath: '/certificate';
      preLoaderRoute: typeof CertificateIndexRoute;
      parentRoute: typeof rootRoute;
    };
    '/certificate/sample': {
      id: '/certificate/sample';
      path: '/certificate/sample';
      fullPath: '/certificate/sample';
      preLoaderRoute: typeof CertificateSampleRoute;
      parentRoute: typeof rootRoute;
    };
    '/admin/pages': {
      id: '/admin/pages';
      path: '/admin/pages';
      fullPath: '/admin/pages';
      preLoaderRoute: typeof AdminPagesRoute;
      parentRoute: typeof rootRoute;
    };
    '/admin/pages/$slug': {
      id: '/admin/pages/$slug';
      path: '/admin/pages/$slug';
      fullPath: '/admin/pages/$slug';
      preLoaderRoute: typeof AdminPagesSlugRoute;
      parentRoute: typeof rootRoute;
    };
    '/about': {
      id: '/about';
      path: '/about';
      fullPath: '/about';
      preLoaderRoute: typeof AboutRoute;
      parentRoute: typeof rootRoute;
    };
    '/how-it-works': {
      id: '/how-it-works';
      path: '/how-it-works';
      fullPath: '/how-it-works';
      preLoaderRoute: typeof HowItWorksRoute;
      parentRoute: typeof rootRoute;
    };
    '/terms': {
      id: '/terms';
      path: '/terms';
      fullPath: '/terms';
      preLoaderRoute: typeof TermsRoute;
      parentRoute: typeof rootRoute;
    };
    '/terms/$version': {
      id: '/terms/$version';
      path: '/terms/$version';
      fullPath: '/terms/$version';
      preLoaderRoute: typeof TermsVersionRoute;
      parentRoute: typeof rootRoute;
    };
    '/privacy': {
      id: '/privacy';
      path: '/privacy';
      fullPath: '/privacy';
      preLoaderRoute: typeof PrivacyRoute;
      parentRoute: typeof rootRoute;
    };
    '/privacy/$version': {
      id: '/privacy/$version';
      path: '/privacy/$version';
      fullPath: '/privacy/$version';
      preLoaderRoute: typeof PrivacyVersionRoute;
      parentRoute: typeof rootRoute;
    };
    '/sla': {
      id: '/sla';
      path: '/sla';
      fullPath: '/sla';
      preLoaderRoute: typeof SlaRoute;
      parentRoute: typeof rootRoute;
    };
    '/sla/$version': {
      id: '/sla/$version';
      path: '/sla/$version';
      fullPath: '/sla/$version';
      preLoaderRoute: typeof SlaVersionRoute;
      parentRoute: typeof rootRoute;
    };
  }
}

const AccountSecurityRouteWithChildren = AccountSecurityRoute.update({
  id: '/account/security',
  path: '/account/security',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/account/security.lazy').then((d) => d.Route));

const AccountWriterKeysRouteWithChildren = AccountWriterKeysRoute.update({
  id: '/account/writer-keys',
  path: '/account/writer-keys',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/account/writer-keys.lazy').then((d) => d.Route));

const CliLoginRouteWithChildren = CliLoginRoute.update({
  id: '/cli-login',
  path: '/cli-login',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/cli-login.lazy').then((d) => d.Route));

const ArtArtworkIdRouteWithChildren = ArtArtworkIdRoute.update({
  id: '/art/$artworkId',
  path: '/art/$artworkId',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/art/$artworkId.lazy').then((d) => d.Route));

const IndexRouteWithChildren = IndexRoute.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/index.lazy').then((d) => d.Route));

const AuthAcceptTermsRouteWithChildren = AuthAcceptTermsRoute.update({
  id: '/auth/accept-terms',
  path: '/auth/accept-terms',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/auth/accept-terms.lazy').then((d) => d.Route));

const AuthLoginRouteWithChildren = AuthLoginRoute.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/auth/login.lazy').then((d) => d.Route));

const AuthPasswordResetRouteWithChildren = AuthPasswordResetRoute.update({
  id: '/auth/password-reset',
  path: '/auth/password-reset',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/auth/password-reset.lazy').then((d) => d.Route));

const AuthPasswordResetConfirmRouteWithChildren = AuthPasswordResetConfirmRoute.update({
  id: '/auth/password-reset-confirm',
  path: '/auth/password-reset-confirm',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/auth/password-reset-confirm.lazy').then((d) => d.Route));

const AdminIndexRouteWithChildren = AdminIndexRoute.update({
  id: '/admin/',
  path: '/admin',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/admin/index.lazy').then((d) => d.Route));

const AdminRequestsRouteWithChildren = AdminRequestsRoute.update({
  id: '/admin/requests',
  path: '/admin/requests',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/admin/requests.lazy').then((d) => d.Route));

const AdminProvenanceProposalsRouteWithChildren = AdminProvenanceProposalsRoute.update({
  id: '/admin/provenance-proposals',
  path: '/admin/provenance-proposals',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/admin/provenance-proposals.lazy').then((d) => d.Route));

const AdminRolesRouteWithChildren = AdminRolesRoute.update({
  id: '/admin/roles',
  path: '/admin/roles',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/admin/roles.lazy').then((d) => d.Route));

const AdminNotificationsRouteWithChildren = AdminNotificationsRoute.update({
  id: '/admin/notifications',
  path: '/admin/notifications',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/admin/notifications.lazy').then((d) => d.Route));

const AdminNotificationsCreateRouteWithChildren = AdminNotificationsCreateRoute.update({
  id: '/admin/notifications/create',
  path: '/admin/notifications/create',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/admin/notifications.create.lazy').then((d) => d.Route));

const AdminArtworkChangesRouteWithChildren = AdminArtworkChangesRoute.update({
  id: '/admin/artwork-changes',
  path: '/admin/artwork-changes',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/admin/artwork-changes.lazy').then((d) => d.Route));

const AdminUsersRouteWithChildren = AdminUsersRoute.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/admin/users.lazy').then((d) => d.Route));

const AdminArtworksUuidRouteWithChildren = AdminArtworksUuidRoute.update({
  id: '/admin/artworks/$uuid',
  path: '/admin/artworks/$uuid',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/admin/artworks.$uuid.lazy').then((d) => d.Route));

const AdminUsersIdRouteWithChildren = AdminUsersIdRoute.update({
  id: '/admin/users/$id',
  path: '/admin/users/$id',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/admin/users.$id.lazy').then((d) => d.Route));

const AdminEscrowRouteWithChildren = AdminEscrowRoute.update({
  id: '/admin/escrow',
  path: '/admin/escrow',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/admin/escrow.lazy').then((d) => d.Route));

const AdminEscrowSaleIdRouteWithChildren = AdminEscrowSaleIdRoute.update({
  id: '/admin/escrow/$saleId',
  path: '/admin/escrow/$saleId',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/admin/escrow.$saleId.lazy').then((d) => d.Route));

const ItemUuidRouteWithChildren = ItemUuidRoute.update({
  id: '/item/$uuid',
  path: '/item/$uuid',
  getParentRoute: () => rootRoute,
});

const PassportConfirmRequestIdRouteWithChildren = PassportConfirmRequestIdRoute.update({
  id: '/passport/confirm/$requestId',
  path: '/passport/confirm/$requestId',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/passport/confirm.$requestId.lazy').then((d) => d.Route));

const TagUuidRouteWithChildren = TagUuidRoute.update({
  id: '/tag/$uuid',
  path: '/tag/$uuid',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/tag/$uuid.lazy').then((d) => d.Route));

const TagFailedRouteWithChildren = TagFailedRoute.update({
  id: '/tag/failed',
  path: '/tag/failed',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/tag/failed.lazy').then((d) => d.Route));

const TagRetiredUuidRouteWithChildren = TagRetiredUuidRoute.update({
  id: '/tag/retired/$uuid',
  path: '/tag/retired/$uuid',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/tag/retired.$uuid.lazy').then((d) => d.Route));

const CertificateIndexRouteWithChildren = CertificateIndexRoute.update({
  id: '/certificate/',
  path: '/certificate',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/certificate/index.lazy').then((d) => d.Route));

const CertificateSampleRouteWithChildren = CertificateSampleRoute.update({
  id: '/certificate/sample',
  path: '/certificate/sample',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/certificate/sample.lazy').then((d) => d.Route));

const AdminPagesRouteWithChildren = AdminPagesRoute.update({
  id: '/admin/pages',
  path: '/admin/pages',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/admin/pages.lazy').then((d) => d.Route));

const AdminPagesSlugRouteWithChildren = AdminPagesSlugRoute.update({
  id: '/admin/pages/$slug',
  path: '/admin/pages/$slug',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/admin/pages.$slug.lazy').then((d) => d.Route));

const AboutRouteWithChildren = AboutRoute.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/about.lazy').then((d) => d.Route));

const HowItWorksRouteWithChildren = HowItWorksRoute.update({
  id: '/how-it-works',
  path: '/how-it-works',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/how-it-works.lazy').then((d) => d.Route));

const TermsRouteWithChildren = TermsRoute.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/terms.lazy').then((d) => d.Route));

const TermsVersionRouteWithChildren = TermsVersionRoute.update({
  id: '/terms/$version',
  path: '/terms/$version',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/terms.$version.lazy').then((d) => d.Route));

const PrivacyRouteWithChildren = PrivacyRoute.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/privacy.lazy').then((d) => d.Route));

const PrivacyVersionRouteWithChildren = PrivacyVersionRoute.update({
  id: '/privacy/$version',
  path: '/privacy/$version',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/privacy.$version.lazy').then((d) => d.Route));

const SlaRouteWithChildren = SlaRoute.update({
  id: '/sla',
  path: '/sla',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/sla.lazy').then((d) => d.Route));

const SlaVersionRouteWithChildren = SlaVersionRoute.update({
  id: '/sla/$version',
  path: '/sla/$version',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/sla.$version.lazy').then((d) => d.Route));

export const coreChildren = {
  AccountSecurityRoute: AccountSecurityRouteWithChildren,
  AccountWriterKeysRoute: AccountWriterKeysRouteWithChildren,
  CliLoginRoute: CliLoginRouteWithChildren,
  ArtArtworkIdRoute: ArtArtworkIdRouteWithChildren,
  IndexRoute: IndexRouteWithChildren,
  AuthAcceptTermsRoute: AuthAcceptTermsRouteWithChildren,
  AuthLoginRoute: AuthLoginRouteWithChildren,
  AuthPasswordResetRoute: AuthPasswordResetRouteWithChildren,
  AuthPasswordResetConfirmRoute: AuthPasswordResetConfirmRouteWithChildren,
  AdminIndexRoute: AdminIndexRouteWithChildren,
  AdminRequestsRoute: AdminRequestsRouteWithChildren,
  AdminProvenanceProposalsRoute: AdminProvenanceProposalsRouteWithChildren,
  AdminArtworkChangesRoute: AdminArtworkChangesRouteWithChildren,
  AdminRolesRoute: AdminRolesRouteWithChildren,
  AdminNotificationsRoute: AdminNotificationsRouteWithChildren,
  AdminNotificationsCreateRoute: AdminNotificationsCreateRouteWithChildren,
  AdminUsersRoute: AdminUsersRouteWithChildren,
  AdminArtworksUuidRoute: AdminArtworksUuidRouteWithChildren,
  AdminUsersIdRoute: AdminUsersIdRouteWithChildren,
  AdminEscrowRoute: AdminEscrowRouteWithChildren,
  AdminEscrowSaleIdRoute: AdminEscrowSaleIdRouteWithChildren,
  ItemUuidRoute: ItemUuidRouteWithChildren,
  PassportConfirmRequestIdRoute: PassportConfirmRequestIdRouteWithChildren,
  TagUuidRoute: TagUuidRouteWithChildren,
  TagFailedRoute: TagFailedRouteWithChildren,
  TagRetiredUuidRoute: TagRetiredUuidRouteWithChildren,
  CertificateIndexRoute: CertificateIndexRouteWithChildren,
  CertificateSampleRoute: CertificateSampleRouteWithChildren,
  AdminPagesRoute: AdminPagesRouteWithChildren,
  AdminPagesSlugRoute: AdminPagesSlugRouteWithChildren,
  AboutRoute: AboutRouteWithChildren,
  HowItWorksRoute: HowItWorksRouteWithChildren,
  TermsRoute: TermsRouteWithChildren,
  TermsVersionRoute: TermsVersionRouteWithChildren,
  PrivacyRoute: PrivacyRouteWithChildren,
  PrivacyVersionRoute: PrivacyVersionRouteWithChildren,
  SlaRoute: SlaRouteWithChildren,
  SlaVersionRoute: SlaVersionRouteWithChildren,
};
